export enum TableIdentifiers {
  Orders = "orders",
  WorkQueue = "workQueue",
  TradingPartner = "tradingPartner",
  CustomerInventory = "customerInventory",
  WebhookLogs = "webhookLogs"
}
